function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomFlowerGardenViewRiverViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.846 15.467a1 1 0 01-.313 1.379l-1.501.946c-.881.556-.744 1.88.232 2.244l.098.037a3.151 3.151 0 01.46 5.691l-7.196 4.1-.99-1.738 7.196-4.1a1.151 1.151 0 00-.168-2.08l-.099-.036c-2.527-.942-2.881-4.371-.6-5.81l1.502-.946a1 1 0 011.379.313zm-8.018-.027a1 1 0 01-.268 1.388l-2.89 1.955a.56.56 0 00.042.954c1.913 1.057 1.706 3.87-.34 4.637l-4.162 1.56-6.344 2.496a1 1 0 11-.732-1.86l6.358-2.503L13.67 22.5a.56.56 0 00.074-1.014c-1.673-.925-1.778-3.29-.195-4.361l2.891-1.955a1 1 0 011.388.269z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 17H4v-2h24.5v2zM19.39 8.712c.079 0 .159 0 .238.083.398.164.797 0 .956-.411.319-.494.717-.74 1.195-.74.557 0 1.115.41 1.274.986.08.329.398.575.797.575.318 0 .557.247.557.576 0 .329-.239.575-.557.575h-4.46a.81.81 0 01-.797-.822c0-.493.319-.822.796-.822zm0 3.288h4.46c1.194 0 2.15-.986 2.15-2.22 0-.985-.637-1.89-1.593-2.136A2.949 2.949 0 0021.78 6c-.876 0-1.673.41-2.23 1.068h-.16C18.115 7.068 17 8.137 17 9.534 17 10.85 18.035 12 19.39 12z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16v-4h2v4H8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10V8a1 1 0 00-2 0v2a1 1 0 102 0zM9 5a3 3 0 00-3 3v2a3 3 0 006 0V8a3 3 0 00-3-3z",
    fill: props.color
  }));
}

export default SvgIconRoomFlowerGardenViewRiverViewFilled;